// extracted by mini-css-extract-plugin
module.exports = {"container":"StaticPageChrome__container___3ADAt","logoWrap":"StaticPageChrome__logoWrap___KZ2Co","logo":"StaticPageChrome__logo___1ziy6","text":"StaticPageChrome__text___3N4VS"};